const DATA_TEST_IDS = {
  geoValidatedAddressView: 'profile-address__geo-validated-address-view',
} as const;

export default DATA_TEST_IDS;
